import { useEffect, useRef } from "react";
import { useState } from "react";
import DocumentMeta from "react-document-meta";
import ExchangeKycHeader from "../Common/ExchangeHeader";
import { toast, ToastContainer } from "react-toastify";
import Ticker from "./ticker";
import { PairList } from "./pairlist";
import TradingViewChart from "../ExchangeFull/TradingView";
import { Depth } from "./depth";
import { SpotBalance } from "./SpotBalance";
import { OrderHistory } from "./OrderHistory";
import { PendingOrders } from "./PendingOrders";
import { CompletedOrders } from "./CompletedOrders";
import { Post } from "../services/api";
import { BuyBoxHtml } from "./Buy";
import { confirmAlert } from "react-confirm-alert";
import { SellBoxHtml } from "./Sell";
import { formatDigit } from "./format.util";
import { use } from "react";
import Swal from "sweetalert2";

// import { SellBoxHtml } from "./Sell";
// import { BuyBoxHtml } from "./Buy";
// import { Depth } from "./depth";
// import { SpotBalance } from "./SpotBalance";
// import { PendingOrders } from "./PendingOrders";
// import { CompletedOrders } from "./CompletedOrders";
// import { OrderHistory } from "./OrderHistory";

let refresher = 1;

const CryptoTrade = ({ pair, socket, portfolio }) => {
  const buyOrdersRef = useRef(null);
  const buy_sell_ref = useRef(null);

  const graphOrdersRef = useRef(null);
  const marketRef = useRef(null);

  const myOrdersRef = useRef(null);

  const [sellOrders, set_sellOrders] = useState([]);
  const [buyOrders, set_buyOrders] = useState([]);
  const [historyOrders, set_historyOrders] = useState([]);

  const [orderSide, set_orderSide] = useState("Buy");
  const [orderStatus, set_orderStatus] = useState("Pending");

  const [pairList, set_pairList] = useState([]);

  const scrollToMYOrders = () => {
    if (myOrdersRef.current) {
      myOrdersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToBuyOrders = () => {
    if (buyOrdersRef.current) {
      buyOrdersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToBuySell = () => {
    console.log("click");
    if (buy_sell_ref.current) {
      buy_sell_ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToGraph = () => {
    if (graphOrdersRef.current) {
      graphOrdersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollTomarket = () => {
    if (marketRef.current) {
      marketRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [themeRefresh, setThemeRefresh] = useState(false);

  const [refresh, set_refresh] = useState(1);

  const [port_folio, set_port_folio] = useState(portfolio);

  const [params, set_params] = useState({
    firstCoin: "BTC",
    secondCoin: "USDT",
  });

  const [firstCoin, setFirstCoin] = useState("");
  const [secondCoin, setSecondCoin] = useState("");

  const [marketBuyPrice, set_marketBuyPrice] = useState(0);
  const [marketSellPrice, set_marketSellPrice] = useState(0);

  const [ProductName, setProductName] = useState("Ven-Crypto");

  const [currentPrice, set_currentPrice] = useState(0);

  const [concatpair, set_concatpair] = useState();

  const [fav, set_fav] = useState(false);

  const [favRefresh, set_favRefresh] = useState(false);

  const [initialPrice, set_initialPrice] = useState(0);

  useEffect(() => {
    if (pair) {
      const [first, second] = pair.split("/");
      setFirstCoin(first);
      setSecondCoin(second);

      set_params({ firstCoin: first, secondCoin: second });
      set_concatpair(pair.replace(/\//g, "").toLowerCase());
    }
  }, [pair]); // Run the effect whenever the 'pair' prop changes

  useEffect(() => {
    if (!localStorage.getItem("jwtToken") || !pair) return;

    socket.on("portfolio", (data) => {
      set_port_folio(data);
    });

    socket.emit(
      "fav_pairs_action", // matches the backend socket.on event name
      {
        action: "check_fav",
        pair: pair,
      },
      (response) => {
        if (response.status) {
          set_fav(response.data); // backend returns true/false from isFavorite
        } else {
          toast.error(response.message || "Failed to check fav pair or not");
        }
      }
    );
  }, [pair]);

  useEffect(() => {
    if (!localStorage.getItem("jwtToken") || !pair) return;

    socket.emit(
      "fav_pairs_action", // matches the backend socket.on event name
      {
        action: "check_fav",
        pair: pair,
      },
      (response) => {
        if (response.status) {
          set_fav(response.data); // backend returns true/false from isFavorite
        } else {
          toast.error(response.message || "Failed to check fav pair or not");
        }
      }
    );
  }, [pair]);

  const add_to_fav = () => {
    if (!localStorage.getItem("jwtToken")) {
      toast.error("Please login to add favourite");
      return;
    }

    // Emit the socket event
    socket.emit(
      "fav_pairs_action", // event name expected on backend
      {
        action: "toggle",
        pair: pair,
      },
      (response) => {
        if (response.status) {
          set_fav(response.data.status); // assuming backend returns updated fav list or bool
          console.log("response.data",response.data)
          set_favRefresh((prev) => !prev);
        } else {
          toast.error(response.message || "Failed to add favourite");
        }
      }
    );
  };

  const refreshPage = () => {
    set_refresh(++refresher);
  };
  const [ticker, set_ticker] = useState({});
  useEffect(() => {
    console.log(concatpair, "yes");
    socket.on(concatpair, (data) => {
      if (data.ticker) {
        set_currentPrice(formatDigit(data.ticker.cur_last_price));
        set_ticker(data.ticker);
      }
      if (data.asks) {
        const best_seller = data.asks[0]?.price || 0;
        set_marketSellPrice(best_seller);
        set_sellOrders(data.asks);
      }
      if (data.bids) {
        const best_buyer = data.bids[0]?.price || 0;

        set_marketBuyPrice(best_buyer);

        set_buyOrders(data.bids);
      }

      if (data.trade) {
        set_historyOrders(data.trade);
      }
    });
    return () => {
      socket.off(concatpair); // Remove the event listener
    };
  }, [concatpair]);

  useEffect(() => {
    socket.on("order_update", (data) => {
      console.log(
        "update order come form the backend for the show the mesaage in the toaster anmdf rtemoeve the loader from the buy sell button",
        data
      );

      toast.success(data);
      setTimeout(() => {
        refreshPage();
      }, 10);
    });

    socket.on("pairs_list", (data) => {
      set_pairList(data);
    });

    // socket.on("inr_pairs_list", (data) => {
    //     set_pairslist(data)
    // });
    return () => {
      socket.off("order_update"); // Remove the event listener
    };
  }, []);

  useEffect(() => {
    if (!concatpair) return;
    socket.emit(
      "get_ticker_info", // event name in your backend where get_ticker is bound
      { pair: `${firstCoin}/${secondCoin}` },
      (response) => {        
        if (response.status) {
          const data = response.data;

          if (data.ticker) {
            set_currentPrice(data.ticker.cur_last_price);

            set_initialPrice(String(data.ticker.cur_last_price));
            set_ticker(data.ticker);
          }

          if (data.asks) {
            const best_seller = data.asks[0]?.price || 0;
            set_marketSellPrice(best_seller);
            set_sellOrders(data.asks);
          }

          if (data.bids) {
            const best_buyer = data.bids[0]?.price || 0;
            set_marketBuyPrice(best_buyer);
            set_buyOrders(data.bids);
          }

          if (data.trade) {
            set_historyOrders(data.trade);
          }
        } else {
          toast.error(response.message || "Failed to get pair data");
        }
      }
    );
  }, [concatpair]);

  useEffect(() => {
    socket.emit(
      "get_pair_list", // event name in your backend where get_ticker is bound
      {},
      (response) => {
        if (response.status) {
          const data = response.data;

          set_pairList(data);
        } else {
          toast.error(response.message || "Failed to get pair list");
        }
      }
    );
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.on("force_logout", (data) => {

      console.log("force logout event received", data);
      const theme = localStorage.getItem("theme");
      Swal.fire({
        title: "Session Expired",
        html: "You will be redirected in <b></b> seconds.",
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          const b = Swal.getHtmlContainer().querySelector("b");
          const timerInterval = setInterval(() => {
            b.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
          }, 100);
          Swal.showLoading();
          Swal.willClose = () => clearInterval(timerInterval);
        },
      }).then(() => {
        localStorage.clear();
        localStorage.setItem("theme", theme);
        window.location.href = "/login";
      });
    });

    // cleanup to avoid memory leaks
    return () => {
      socket.off("force_logout");
    };
  }, [socket]);

  const changeTheme = () => {
    setThemeRefresh(!themeRefresh);
  };

  let title = `${currentPrice}\xa0\xa0| \xa0\xa0${firstCoin}${secondCoin}\xa0\xa0| \xa0\xa0${ProductName} Exchange`;

  const meta = {
    title: title,
    description: `${ProductName}  Exchange Live Is A Crypto Trading Platform That Exchanges Cryptocurrencies Like Bitcoin, Dogecoin, TRX, XRP, MRC etc. Sign Up For A New Account.`,
    canonical: `https://${ProductName} Exchange.com/high-limit-crypto-exchange`,
    meta: {
      charset: "utf-8",
      name: {
        keywords:
          "Bitcoin Exchange, Crypto Buying Selling, Crypto Platform, Cryptocurrencies App ",
      },
    },
  };

  // const sideLastHtml = () => {
  //     if (topBarStatus !== false) {
  //         if (exchange === "binance") {
  //             return (
  //                 <ul>
  //                     <li>
  //                         <strong className="ng-binding mm">
  //                             {formatDecimal(livPrice)}
  //                         </strong>
  //                         <strong className="transMoney ng-binding ng-scope"></strong>
  //                     </li>
  //                 </ul>
  //             );
  //         } else {
  //             var topBarData = topBarApiData;
  //             var collectHtml = (
  //                 <ul>
  //                     <li>
  //                         <strong className="ng-binding mm">
  //                             {formatDecimal(topBarData.currentPrice)}
  //                         </strong>
  //                         <strong className="transMoney ng-binding ng-scope"></strong>
  //                     </li>
  //                 </ul>
  //             );
  //         }

  //         return <ul>{collectHtml}</ul>;
  //     } else {
  //         collectHtml = (
  //             <ul>
  //                 <li>
  //                     <strong className="ng-binding">
  //                         {secondCoin === "INR" ? (
  //                             <span style={{ color: "#07bc8d", fontWeight: "500" }}>₹</span>
  //                         ) : (
  //                             <span></span>
  //                         )}
  //                         {0.0}
  //                     </strong>
  //                     <strong className="transMoney ng-binding ng-scope"></strong>
  //                 </li>
  //             </ul>
  //         );
  //         return <ul>{collectHtml}</ul>;
  //     }
  // };

  return (
    <>
      <DocumentMeta {...meta}>
        <ExchangeKycHeader
          graphColor={changeTheme}
          portfolioData={port_folio}
        />
        <div className="bghwhite">
          <div className="dashbord_manbox dashbord_manbox_das exchange-main-outer">
            <div className="container-fluid">
              <div className="dashbord_in1">
                <div className="dashbord_in dashbord_in_top fs12">
                  <div className="kline-para kline-para-basic d-flex align-items-center">
                    <div className="box-kline-para-basic-left">
                      <span className="productSymbol has-info ng-scope">
                        <strong className="ng-binding">
                          {localStorage.getItem("jwtToken") && (
                            <div
                              onClick={() => {
                                add_to_fav();
                              }}
                              style={{ display: "inline" }}
                            >
                              {fav ? (
                                <i className="fa fa-star"></i> // Default star when fav is false
                              ) : (
                                <i
                                  className="fa fa-star-o"
                                ></i> // Grey star when fav is true
                              )}
                            </div>
                          )}
                          {firstCoin}
                        </strong>
                        <font className="ng-binding"> / {secondCoin}</font>
                      </span>
                    </div>
                    <div className="box-kline-para-basic-right">
                      <Ticker ticker={ticker}></Ticker>
                      <div className="cls"></div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      ref={marketRef}
                      className="col-md-3 padding-right exchange_left  mb-2"
                    >
                      <PairList
                        PairList={pairList}
                        firstCoin={firstCoin}
                        secondCoin={secondCoin}
                        favRefresh={favRefresh}
                        socket={socket}
                      />
                    </div>

                    <div ref={graphOrdersRef} className="col-md-6 mb-2">
                      <div className="ne_box p-0">
                        <TradingViewChart
                          params={params}
                          graphColor={themeRefresh}
                        />
                      </div>

                      <div className="dp_none status-outer">
                        <ul class="nav nav-tabs2 ">
                          <li class="nav-item">
                            <a
                              class="nav-link active m-2"
                              data-toggle="tab"
                              href="#buymobile"
                            >
                              Buy {firstCoin}
                            </a>
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link m-2"
                              data-toggle="tab"
                              href="#sellmobile"
                            >
                              Sell {secondCoin}
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="row tab-content h306 mt-2 ">
                        <div
                          className="col-md-6 tab-pane active d-show"
                          id="buymobile"
                        >
                          <div ref={buy_sell_ref} className="ne_box h_100 ">
                            <BuyBoxHtml
                              firstCoin={firstCoin}
                              secondCoin={secondCoin}
                              marketSellPrice={marketSellPrice}
                              initialPrice={initialPrice}
                              refresh={refresh}
                              refreshPage={refreshPage}
                              socket={socket}
                            />
                          </div>
                        </div>
                        <div
                          className="col-md-6  tab-pane dp_block d-show mt-md-0 mt-2"
                          id="sellmobile"
                        >
                          <div className="ne_box h_100 ">
                            <SellBoxHtml
                              firstCoin={firstCoin}
                              secondCoin={secondCoin}
                              marketBuyPrice={marketBuyPrice}
                              initialPrice={initialPrice}
                              refresh={refresh}
                              refreshPage={refreshPage}
                              socket={socket}
                            />
                            {/* <SellBoxHtml /> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 mb-2">
                      <div className="ne_box h_100 br_0 order_bistory market-trade">
                        <h6>Market Depth</h6>
                        <div className="market-depth-sell">
                          <table className="table mb-0 market_bepth_table ">
                            <tr>
                              <th>Price</th>
                              <th>Qty.</th>
                              <th className="text-right">
                                Total({secondCoin})
                              </th>
                            </tr>
                            <Depth orders={sellOrders} side="sell" />
                          </table>
                        </div>
                        <h6 className="text-center t2t live-price">
                          <ul>
                            <li>
                              <strong className="ng-binding ">
                                {currentPrice}
                              </strong>
                              <strong className="transMoney ng-binding ng-scope"></strong>
                            </li>
                          </ul>
                        </h6>
                        <div className="market-depth-sell">
                          <table className="table mb-0 market_bepth_table">
                            <tr>
                              <th>Price</th>
                              <th>Qty.</th>
                              <th className="text-right">
                                Total({secondCoin})
                              </th>
                            </tr>
                            <Depth orders={buyOrders} side="buy" />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="color-background orderform-main">
                    <div className="row mt-2 mt-md-0">
                      <div className="col-md-3 ">
                        <SpotBalance refresh={refresh} socket={socket} />
                      </div>

                      <div className="col-md-6 mt-3 mt-md-0">
                        <div className="ne_box h_100">
                          <div
                            ref={myOrdersRef}
                            className="table_hadding flex-wrap"
                          >
                            <h6 className="h6_head">My Orders</h6>
                            <div className="status-outer ">
                              <ul className="nav nav-tabs2" role="tablist">
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      orderSide == "Buy" ? "active" : ""
                                    }`}
                                    data-toggle="tab"
                                    onClick={() => {
                                      set_orderSide("Buy");
                                    }}
                                    role="tab"
                                  >
                                    Buy
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      orderSide == "Sell" ? "active" : ""
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => {
                                      set_orderSide("Sell");
                                    }}
                                  >
                                    Sell
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="buy-order-outer tab-content">
                            <div
                              className="tab-pane active"
                              id="Buytab"
                              role="tabpanel"
                            >
                              <div className="table_hadding flex-wrap table_hadding2">
                                <h6 className="h6_head">{orderSide} Orders</h6>
                                <div className="status-outer">
                                  <div
                                    className="nav s_tabs mb-2"
                                    role="tablist"
                                  >
                                    <span
                                      className={`nav-link ${
                                        orderStatus == "Pending" ? "active" : ""
                                      }`}
                                      data-toggle="tab"
                                      onClick={() => {
                                        set_orderStatus("Pending");
                                      }}
                                      role="tab"
                                    >
                                      Pending
                                    </span>

                                    <span
                                      className={`nav-link ${
                                        orderStatus == "Completed"
                                          ? "active"
                                          : ""
                                      }`}
                                      data-toggle="tab"
                                      onClick={() => {
                                        set_orderStatus("Completed");
                                      }}
                                      role="tab"
                                    >
                                      Completed
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="buy-order-outer tab-content">
                                {orderStatus == "Pending" && (
                                  <PendingOrders
                                    side={orderSide}
                                    refresh={refresh}
                                    refreshPage={refreshPage}
                                    socket={socket}
                                  />
                                )}
                                {orderStatus == "Completed" && (
                                  <CompletedOrders
                                    side={orderSide}
                                    refresh={refresh}
                                    socket={socket}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 mt-3 mt-md-0">
                        <OrderHistory orders={historyOrders} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>

        {/* <ExchangeHeader
            graphColor={this.changeTheme}
            portfolioData={this.state.portfolioData}
          /> */}
      </DocumentMeta>
    </>
  );
};

export { CryptoTrade };
